var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectiveActionRequestDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3659 17.2998C17.0493 17.2998 16.7326 17.1831 16.4826 16.9331L15.2326 15.6831C14.7493 15.1998 14.7493 14.3998 15.2326 13.9165C15.7159 13.4331 16.5159 13.4331 16.9993 13.9165L17.3659 14.2831L20.2326 11.4165C20.7159 10.9331 21.5159 10.9331 21.9993 11.4165C22.4826 11.8998 22.4826 12.6998 21.9993 13.1831L18.2493 16.9331C18.0159 17.1665 17.6993 17.2998 17.3659 17.2998Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8668 16.0332H26.1168C25.4335 16.0332 24.8668 15.4665 24.8668 14.7832C24.8668 14.0999 25.4335 13.5332 26.1168 13.5332H34.8668C35.5502 13.5332 36.1168 14.0999 36.1168 14.7832C36.1168 15.4665 35.5668 16.0332 34.8668 16.0332Z",
    fill: "#5D9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1168 27.6999H34.8668C35.5668 27.6999 36.1168 27.1332 36.1168 26.4499C36.1168 25.7665 35.5502 25.1999 34.8668 25.1999H26.1168C25.4335 25.1999 24.8668 25.7665 24.8668 26.4499C24.8668 27.1332 25.4335 27.6999 26.1168 27.6999Z",
    fill: "#5D9FE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3659 28.9665C17.0493 28.9665 16.7326 28.8498 16.4826 28.5998L15.2326 27.3498C14.7493 26.8665 14.7493 26.0665 15.2326 25.5831C15.7159 25.0998 16.5159 25.0998 16.9993 25.5831L17.3659 25.9498L20.2326 23.0831C20.7159 22.5998 21.5159 22.5998 21.9993 23.0831C22.4826 23.5665 22.4826 24.3665 21.9993 24.8498L18.2493 28.5998C18.0159 28.8331 17.6993 28.9665 17.3659 28.9665Z",
    fill: "#5D9FE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 37.9163H30.5C39.55 37.9163 43.4166 34.0497 43.4166 24.9997V14.9997C43.4166 5.94967 39.55 2.08301 30.5 2.08301H20.5C11.45 2.08301 7.58331 5.94967 7.58331 14.9997V24.9997C7.58331 34.0497 11.45 37.9163 20.5 37.9163ZM10.0833 14.9997C10.0833 7.31634 12.8166 4.58301 20.5 4.58301H30.5C38.1833 4.58301 40.9166 7.31634 40.9166 14.9997V24.9997C40.9166 32.683 38.1833 35.4163 30.5 35.4163H20.5C12.8166 35.4163 10.0833 32.683 10.0833 24.9997V14.9997Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectiveActionRequestDetailIcon);
export default __webpack_public_path__ + "static/media/CorrectiveActionRequestDetailIcon.913842b158a0e225ada639cc9b84618d.svg";
export { ForwardRef as ReactComponent };